export default [
	'Auto',
	'Auto Parts',
	'Bank',
	'Big Box',
	'Cellular Store',
	'Day Care/School',
	'Dollar Store',
	'Drug Store',
	'Dry Cleaner',
	'Entertainment',
	'Fast Food',
	'Fitness',
	'Gas/Convenience Store',
	'Grocery',
	'Home Improvement',
	'Mattress Store',
	'Medical',
	'Office Supply',
	'Other',
	'Pawn Shop',
	'Restaurant',
	'Tractor Supply',
	'Video Store',
];